import { Component } from '@angular/core';
declare var $: any;

@Component({
  selector: 'app-loading-modal',
  templateUrl: './loading-modal.component.html',
  styleUrls: ['./loading-modal.component.css']
})
export class LoadingModalComponent {

  action:boolean = false;

  show(){
    this.action = true;
  }
  hide(){
    this.action = false;
  }
}
